import React from 'react'
import './Store_Product_Card.css'
import { useNavigate } from 'react-router-dom'
import { encodeId } from '../../../../utils/common'

const Store_Product_Card = (props) => {

    const navigate = useNavigate()

    return (
        <section className='Store_Product_Card' onClick={() => {navigate(`/product-details/${encodeId(props?.id)}`)}}>
           

            <div className='img_holder'>
                <img src={process.env.REACT_APP_IMG_URL + props?.img} className='prod_img' />
            </div>

            <div className='text_div'>
                <div className='white_curved_div'>
                    <p className='prod_title'>{props?.name}</p>
                </div>

                {props?.discount && (
                    <div className='discount_div'>
                        <p className='discount_text'>{props?.discount} Off</p>
                    </div>
                )}


            </div>
        </section>
    )
}

export default Store_Product_Card
